

















import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class Success extends Vue {
  goToApp() {
    if (this.iOS) {
      if (this.devHost) {
        window.location.href = "https://testflight.apple.com/join/1FFDnPPO"
      } else if (this.prodHost) {
        window.location.href = "https://apps.apple.com/us/app/novaccess/id1464520347"
      }
    } else {
      window.location.href = "https://play.google.com/store/apps/details?id=com.myjungly.novaccess"
    }
  }
  get iOS() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i)
  }
  get devHost() {
    return (window.location.hostname === "app.novaccess.ovh" ) || (window.location.hostname === "localhost")
  }
  get prodHost() {
    return window.location.hostname === "app.novaccess.co"
  }
}
